'use strict';
(function() {

	class LegendUtils {
		
		constructor(){
			
		}
	
    }

    class EditorLegend{
        static getLegendRowName(layerName){
            var html='';
            html += '<span class="fa fa-arrows"></span>';
			html += '<div class="legend-row" style="display:inline;">';	
            html += '<span style="margin-left: 45px;">'+layerName+'</span></div>'; 
            return html;
        }

        static getLlegendaVisualitzacio(layer,mapLegend){
            var html='';
            var geometryType = InstamapsUtils.Geo.transformTipusGeometry(layer.options.geometryType, InstamapsConstants);
            var rangsEstilsLegend = layer.options.rangsEstilsLegend;
            var arrRangsEstilsLegend = sortObject(rangsEstilsLegend);           
            if(!layer.options.hasOwnProperty("trafficLightKey"))
                arrRangsEstilsLegend.sort(InstamapsUtils.Sort.sortByValueMax);
            else
            {	
                //Si és un semafòric no reordenem els valors de la llegenda, ja ens venen ben assignats i el sortByValueMax se'l carrega
            }
            if (mapLegend!==undefined){
                if (mapLegend[layer.options.businessId]!==undefined){
                    var legend = mapLegend[layer.options.businessId];
                    for(var i=0; i<legend.length;i++){
                        html += EditorLegend.getRowFromMapLegend(layer.options.businessId,layer.options.tem,legend[i]);
                    }
                }
                else {
                    jQuery.each(arrRangsEstilsLegend, function(i, estilRang){
                        var indexEstil = 0;
                        while(indexEstil<layer.options.estil.length && estilRang.key!=layer.options.estil[indexEstil].businessId){
                            indexEstil++;
                        }
                        html += EditorLegend.getRowLayerHtml(mapLegend,layer,rangsEstilsLegend,indexEstil,geometryType,estilRang.key);				
                    });
                }
                
            }
            else{
                jQuery.each(arrRangsEstilsLegend, function(i, estilRang){
                    var indexEstil = 0;
                    while(indexEstil<layer.options.estil.length && estilRang.key!=layer.options.estil[indexEstil].businessId){
                        indexEstil++;
                    }
                    html += EditorLegend.getRowLayerHtml(mapLegend,layer,rangsEstilsLegend,indexEstil,geometryType,estilRang.key);				
                });
            }
            
            return html;
        }

        static getRowClusterHeatmapLayerHtml(layer,checked,layerName) {
            var html = '<div class="legend-subrow " data-businessid="'+layer.options.businessId+'">';
            html += '<input class="col-md-1 legend-chck" type="checkbox" '+checked+' >';
            html += '<div class="col-md-2 legend-symbol" >';
            if (layer.options.tipusRang == tem_heatmap){
                html +=	'<img src="/static/geocatweb/img/heatmap.png" class="btn-paleta" style=""/>';
            }
            else if (layer.options.tipusRang == tem_cluster){
                html +='<img src="/static/geocatweb/img/clustering.png" class="btn-paleta" style=""/>';
            }
            html +='</div>'+
                    '<div class="col-md-9 legend-name">'+
                        '<input type="text" class="form-control my-border" value="'+layerName+'">'+
                    '</div>';
            html+='</div>';
            return html;
        }

        static getRowWmsLayerHtml(layer,checked,layerName,mapLegend){
            var html='';
            if (mapLegend!==undefined){
                if (mapLegend[layer.options.businessId]!==undefined){
                    var legend = mapLegend[layer.options.businessId];
                    for(var i=0; i<legend.length;i++){
                        html += EditorLegend.getRowFromMapLegend(layer.options.businessId,layer.options.tem,legend[i]);
                    }
                }
                else {
                    html += EditorLegend.getRowWmsLayerHtmlIndividual(layer,checked,layerName);
                }
                
            }
            else {
                html += EditorLegend.getRowWmsLayerHtmlIndividual(layer,checked,layerName);
            }
            return html;
        }

        static getRowWmsLayerHtmlIndividual(layer,checked,layerName){
            var html='';
            var key = '';
            if (layer.options.estil!==undefined && layer.options.estil.length>0){
                key = layer.options.estil[0].businessId;
            }
            try{
                var legend_layer = layer.getLegendGraphic();
                html += '<div class="legend-subrow " data-businessid="'+layer.options.businessId+'">';
                html += '<input class="col-md-1 legend-chck" type="checkbox" '+checked+' >';	
                html += '<div class="col-md-2 legend-symbol"  data-estilkey="'+key+'">';
                    if(!jQuery.isArray(legend_layer)){
                        html += '<a href="'+layer.getLegendGraphic()+'" data-lightbox="image-'+layer.options.businessId+'"><img src="'+layer.getLegendGraphic()+'" class="btn-paleta img-legend"/></a>';
                    }else{
                        jQuery.each(legend_layer, function(i, lay){
                            html += '<a href="'+lay+'" data-lightbox="image-'+layer.options.businessId+'"><img src="'+lay+'" class="btn-paleta img-legend"/></a>';
                        });
                    }
                html +=	'</div>'+
                    '<div class="col-md-9 legend-name">'+
                        '<input type="text" class="form-control my-border" value="'+layerName+'">'+
                    '</div>';		
                html+='</div>';	
                
            }catch(exception){
                    
            }finally{
                return html;
            }
            
        }

        
        static getRowJsonLayerHtml(layer,checked,layerName,mapLegend){
            var html='';
            if (mapLegend!==undefined){
                if (mapLegend[layer.options.businessId]!==undefined){
                    var legend = mapLegend[layer.options.businessId];
                    for(var i=0; i<legend.length;i++){
                        html += EditorLegend.getRowFromMapLegend(layer.options.businessId,layer.options.tem,legend[i]);
                    }
                }
                else {
                    html += EditorLegend.getRowJsonLayerHtmlIndividual(layer,checked,layerName);
                }
                
            }
            else {
                html += EditorLegend.getRowJsonLayerHtmlIndividual(layer,checked,layerName);
            }
            return html;
        }

        static getRowJsonLayerHtmlIndividual(layer,checked,layerName){
            var html = '';
            var key = '';
            if (layer.options.estil!==undefined && layer.options.estil.length>0){
                key = layer.options.estil[0].businessId;
            }
            var estil_do = layer.options.estil_do;
            if(layer.options.options && layer.options.options.estil_do) estil_do = layer.options.options.estil_do;//Si es JSON
            else if(estil_do.options) estil_do = estil_do.options;
            if(estil_do.isCanvas || estil_do.markerColor.indexOf("punt_r")!=-1){
                var size="";
                if(estil_do.iconSize){
                    size = 'width: '+estil_do.iconSize.x+'px; height: '+estil_do.iconSize.y+'px;';
                }else{
                    var mida = InstamapsUtils.Styles.getMidaFromRadius(estil_do.radius);
                    if (layer.options.tem == tem_size) mida = estil_do.iconSize;
                    size = 'width: '+mida+'px; height: '+mida+'px; font-size: 8px;';
                }
                var icon = "";
                var colorIcon=""; 
                var auxColor="";
                if(estil_do.divColor){
                    auxColor = InstamapsUtils.Colors.hexToRgb(estil_do.divColor);
                    colorIcon = 'color: rgb('+auxColor.r+', '+auxColor.g+', '+auxColor.b+');';
                } 
                if(estil_do.fillColor){
                    auxColor = InstamapsUtils.Colors.hexToRgb(estil_do.fillColor);
                } 
                if(estil_do.icon){
                    icon = "fa fa-"+estil_do.icon;
                }
                html += '<div class="legend-subrow " data-businessid="'+layer.options.businessId+'">';
                html += '<input class="col-md-1 legend-chck" type="checkbox" '+checked+' >';
                if (layer.options.tem != tem_size){
                html +=	'<div class="col-md-2 legend-symbol"  data-estilkey="'+key+'">'+
                            '<div class="awesome-marker-web awesome-marker-icon-punt_r '+icon+' legend-symbol" '+
                                'style="background-color: '+InstamapsUtils.Colors.getRgbText(auxColor)+'; '+
                                ' '+size+'">'+
                            '</div>'+
                        '</div>'+
                        '<div class="col-md-9 legend-name">'+
                            '<input type="text" class="form-control my-border" value="'+layerName+'">'+
                        '</div>';
                }else{
                    if(mida>=60) mida=60;
                    var height=mida*2.8;
                    var padding_left="16px !important";

                    var color = InstamapsUtils.Colors.hexToRgb(estil_do.fillColor);
                    var stringStyle = InstamapsUtils.Styles.getSvgFromRadius(mida,color,$(location).attr('href'));
                    html +=	'<div class="col-md-2 legend-symbol" style="padding-left:'+padding_left+'"  data-estilkey="'+key+'">'+
                            stringStyle;
                            '</div>'+
                            '<div class="col-md-9 legend-name">'+
                                '<input type="text" class="form-control my-border" value="'+layerName+'">'+
                            '</div>';
                }
                html+='</div>';
            }else{
                var color = InstamapsUtils.Colors.hexToRgb(estil_do.iconColor);
                html += '<div class="legend-subrow " data-businessid="'+layer.options.businessId+'">';
                html += '<input class="col-md-1 legend-chck" type="checkbox" '+checked+' >';	
                html += '<div class="col-md-2 legend-symbol"  data-estilkey="'+key+'">'+
                            '<div class="awesome-marker-web awesome-marker-icon-'+estil_do.markerColor+
                                ' fa fa-'+estil_do.icon+'" style="width: 28px; height: 42px; font-size: 14px;'+ 
                                'background-color: transparent; color: '+InstamapsUtils.Colors.getRgbText(color)+';">'+
                            '</div>'+
                        '</div>'+
                        '<div class="col-md-9 legend-name">'+
                            '<input type="text" class="form-control my-border" value="'+layerName+'">'+
                        '</div>';
                html+='</div>';
            }
            return html;
        }

        static getRowXarxesLayerHtml(layer,layerName,mapLegend){
            var html='';
            if (mapLegend!==undefined){
                if (mapLegend[layer.options.businessId]!==undefined){
                    var legend = mapLegend[layer.options.businessId];
                    for(var i=0; i<legend.length;i++){
                        html += EditorLegend.getRowFromMapLegend(layer.options.businessId,layer.options.tem,legend[i]);
                    }
                }
                else {
                    html += EditorLegend.getRowXarxesLayerHtmlIndividual(layer,layerName);
                }
                
            }
            else {
                html += EditorLegend.getRowXarxesLayerHtmlIndividual(layer,layerName);
            }
            return html;
        }

        static getRowXarxesLayerHtmlIndividual(layer,layerName){
            var key = '';
            if (layer.options.estil!==undefined && layer.options.estil.length>0){
                key = layer.options.estil[0].businessId;
            }
            var html='';
            html += '<div class="legend-subrow " data-businessid="'+layer.options.businessId+'">';
            html += '<input class="col-md-1 legend-chck" type="checkbox" '+checked+' >';
            if(layer.options.hashtag){
                html += '<div class="col-md-2 legend-symbol"  data-estilkey="'+key+'">'+
                            '<div class="awesome-marker-web awesome-marker-icon-blue fa fa-twitter" style="width: 28px; height: 42px; font-size: 14px; background-color: transparent;"></div>'+
                        '</div>'+
                        '<div class="col-md-9 legend-name">'+
                            '<input type="text" class="form-control my-border" value="'+layerName+'">'+
                        '</div>';			
            }else{
                html += '<div class="col-md-2 legend-symbol"  data-estilkey="'+key+'">'+
                            '<div class="awesome-marker-web awesome-marker-icon-gray fa fa-book" style="width: 28px; height: 42px; font-size: 14px; background-color: transparent;"></div>'+
                        '</div>'+
                        '<div class="col-md-9 legend-name">'+
                            '<input type="text" class="form-control my-border" value="'+layerName+'">'+
                        '</div>';				
            }
            html+='</div>';
            return html;
        }

        static getRowUrlFileLayerHtml(layer,checked,layerName,mapLegend){
            var html='';
            if (mapLegend!==undefined){
                if (mapLegend[layer.options.businessId]!==undefined){
                    var legend = mapLegend[layer.options.businessId];
                    for(var i=0; i<legend.length;i++){
                        html += EditorLegend.getRowFromMapLegend(layer.options.businessId,layer.options.tem,legend[i]);
                    }
                }
                else {
                    html += EditorLegend.getRowUrlFileLayerHtmlIndividual(layer,checked,layerName);
                }
                
            }
            else {
                html += EditorLegend.getRowUrlFileLayerHtmlIndividual(layer,checked,layerName);
            }
            return html;
        }

        static getRowUrlFileLayerHtmlIndividual(layer,checked,layerName){
            var geometrytype = "";
            var html = "";
            //layer.options.estil[0].businessId;
            jQuery.each(layer._layers, function(i, lay){
                geometrytype = lay.feature.geometry.type.toLowerCase(); 
                return (geometrytype=="");
            });		
            geometrytype = InstamapsUtils.Geo.transformTipusGeometry(geometrytype, InstamapsConstants);
            
            if(layer.options.tem && (layer.options.tem == tem_clasic || layer.options.tem == tem_size)){
                var i = 0;
                var controlColorCategoria = [];//per controlar que aquell color no esta afegit ja a la llegenda
                var estils = layer.options.estil_do.estils;
                estils.sort(InstamapsUtils.Sort.sortByValueMax);
                var label = layer.options.estil_do.dataField;
                if(geometrytype == t_marker){
                        var map={};
                        jQuery.each(layer._layers, function(i, lay){
                            if (layer.options.tem=='sizeTematic'){
                                var radius=lay.options.radius;
                                if (radius!=undefined){
                                    if (map[radius]==undefined) map[radius]=1;
                                    else {
                                        var i=map[radius];
                                        map[radius]=i+1;
                                    }
                                }
                            }
                            else{
                                var color = lay.options.fillColor;
                                if (color!=undefined){
                                    if (map[color]==undefined) map[color]=1;
                                    else {
                                        var i=map[color];
                                        map[color]=i+1;
                                    }
                                }
                            }
                        });
                        jQuery.each(estils, function(i, estilRang){
                            var key = estilRang.codiUnic;
                            var mida = InstamapsUtils.Styles.getMidaFromRadius(estilRang.estil.simbolSize);
                            if (layer.options.tem == tem_size) mida = estilRang.estil.simbolSize; 
                            var iconSize = 'width: '+mida+'px; height: '+mida+'px; font-size: 8px;';						
                            var color = InstamapsUtils.Colors.hexToRgb(estilRang.estil.color);
                            if(mida>=60) mida=60;
                            var height=mida*2.8;
                            var padding_left="16px !important";
                            var stringStyle = InstamapsUtils.Styles.getSvgFromRadius(mida,color,$(location).attr('href'));
                            
                            if (layer.options.tem!=tem_size){
                                stringStyle ='<div class="awesome-marker-web awesome-marker-icon-punt_r legend-symbol" '+
                                    'style="background-color: '+InstamapsUtils.Colors.getRgbText(color)+'; '+
                                    ' '+iconSize+'">'+
                                    '</div>';
                            }
                            
                            var labelNomCategoria = "";
                            checked = "";
                            var index=-1;
                            if (undefined!=mapLegend[layer.options.businessId]) {
                                index = mapLegend[layer.options.businessId]?findStyleInLegend(mapLegend[layer.options.businessId],stringStyle):-1;
                            }
                            
                            if(index != -1){//Si l'ha trobat, fica el seu check i el seu name
                                labelNomCategoria = mapLegend[layer.options.businessId][index].name;
                                if(mapLegend!=undefined && mapLegend[layer.options.businessId]!=undefined && mapLegend[layer.options.businessId][index].chck == true) checked = 'checked="checked"';
                            }else{
                                if(estilRang.valueMax == estilRang.valueMin){
                                    labelNomCategoria = estilRang.valueMax;
                                }else{
                                    labelNomCategoria = estilRang.valueMin +" - "+ estilRang.valueMax;
                                }
                                
                                if(labelNomCategoria == "Altres"){
                                    labelNomCategoria = window.lang.translate("Altres");
                                }
                                if (layer.options.tem=='sizeTematic'){
                                    if (labelNomCategoria.indexOf('('+map[estilRang.estil.simbolSize]+')')==-1 && map[estilRang.estil.simbolSize]!==undefined){
                                        labelNomCategoria = labelNomCategoria+' ('+map[estilRang.estil.simbolSize]+')';
                                    }
                                    
                                }
                                else{
                                    if (labelNomCategoria.indexOf('('+map[estilRang.estil.color]+')')==-1 && map[estilRang.estil.color]!==undefined){
                                        labelNomCategoria = labelNomCategoria+' ('+map[estilRang.estil.color]+')';
                                    }
                                    
                                }
                                
                            }						
                             
                            if (map[estilRang.estil.simbolSize]!==undefined || map[estilRang.estil.color]!==undefined) {
                                html += '<div class="legend-subrow " data-businessid="'+layer.options.businessId+'">';
                                html += '<input class="col-md-1 legend-chck" type="checkbox" '+checked+' >';
                                if (layer.options.tem == tem_size){
                                    html +=	'<div class="col-md-2 legend-symbol" style="padding-left:'+padding_left+'"  data-estilkey="'+key+'">'+
                                                stringStyle+
                                            '</div>'+
                                            '<div class="col-md-9 legend-name" >'+
                                                '<input type="text" class="form-control my-border" value="'+labelNomCategoria+ '">'+
                                            '</div>';
                                }
                                else{
                                    html +=	'<div class="col-md-2 legend-symbol"  data-estilkey="'+key+'">'+
                                                    stringStyle+
                                                '</div>'+
                                                '<div class="col-md-9 legend-name">'+
                                                    '<input type="text" class="form-control my-border" value="'+labelNomCategoria+'">'+
                                                '</div>';
                                }
                                html+='</div>';	
                            }
                            
                        });
    
                    }else if(geometrytype == t_polyline){
                        var map={};
                        jQuery.each(layer._layers, function(i, lay){
                            var color = lay.options.color;
                            if (color!=undefined){
                                if (map[color]==undefined) map[color]=1;
                                else {
                                    var i=map[color];
                                    map[color]=i+1;
                                }
                            }
                        });
                        jQuery.each(estils, function(i, estilRang){
                            var key = estilRang.codiUnic;
                            var color = InstamapsUtils.Colors.hexToRgb(estilRang.estil.color);
                            var lineWidth = estilRang.estil.lineWidth;
                            var stringStyle =	'<svg height="20" width="20">'+
                                                    '<line x1="0" y1="20" x2="20" y2="0" '+
                                                        'style="stroke:'+InstamapsUtils.Colors.getRgbText(color)+'; stroke-width:'+lineWidth+';"></line>'+
                                                '</svg>';	
                            
                            var labelNomCategoria = "";
                            checked = "";
                            
                            var index=-1;
                            if (undefined!=mapLegend[layer.options.businessId]) {
                                index = mapLegend[layer.options.businessId]?findStyleInLegend(mapLegend[layer.options.businessId],stringStyle):-1;
                            }
                            
                            if(index != -1){//Si l'ha trobat, fica el seu check i el seu name
                                labelNomCategoria = mapLegend[layer.options.businessId][index].name;
                                if(mapLegend!=undefined && mapLegend[layer.options.businessId]!=undefined && mapLegend[layer.options.businessId][index].chck == true) checked = 'checked="checked"';
                            }else{
                                if(estilRang.valueMax == estilRang.valueMin){
                                    labelNomCategoria = estilRang.valueMax;
                                }else{
                                    labelNomCategoria = estilRang.valueMin +" - "+ estilRang.valueMax;
                                }
                                
                                if(labelNomCategoria == "Altres"){
                                    labelNomCategoria = window.lang.translate("Altres");
                                }
                                if (layer.options.tem=='sizeTematic'){
                                    if (labelNomCategoria.indexOf('('+map[estilRang.estil.simbolSize]+')')==-1){
                                        labelNomCategoria = labelNomCategoria+' ('+map[estilRang.estil.simbolSize]+')';
                                    }
                                    
                                }
                                else{
                                    if (labelNomCategoria.indexOf('('+map[estilRang.estil.color]+')')==-1){
                                        labelNomCategoria = labelNomCategoria+' ('+map[estilRang.estil.color]+')';
                                    }
                                    
                                }
                                
                            }	
                            
                            html += '<div class="legend-subrow " data-businessid="'+layer.options.businessId+'">';
                            html += '<input class="col-md-1 legend-chck" type="checkbox" '+checked+' >';
                            html +=	'<div class="col-md-2 legend-symbol"  data-estilkey="'+key+'">'+
                                    stringStyle+
                                '</div>'+
                                '<div class="col-md-9 legend-name">'+
                                    '<input type="text" class="form-control my-border" value="'+labelNomCategoria+'">'+
                                '</div>';				
                            html+='</div>';	
                        });					
                    }else if(geometrytype == t_polygon){
                        var map={};
                        jQuery.each(layer._layers, function(i, lay){
                            if (lay.options!=undefined){
                                if (lay.options.fillColor!=undefined) {
                                    var color = lay.options.fillColor;
                                    if (color!=undefined){
                                        if (map[color]==undefined) map[color]=1;
                                        else {
                                            var i=map[color];
                                            map[color]=i+1;
                                        }
                                    }
                                }				
                            }
                            else {
                                if (lay.getLayers()[0].options!=undefined){
                                    if (lay.getLayers()[0].options.fillColor!=undefined) {
                                        var color = lay.getLayers()[0].options.fillColor;
                                        if (color!=undefined){
                                            if (map[color]==undefined) map[color]=1;
                                            else {
                                                var i=map[color];
                                                map[color]=i+1;
                                            }
                                        }
                                    }				
                                }
                            }
                        });
                        jQuery.each(estils, function(i, estilRang){
                            var key = estilRang.codiUnic;
                            var color = "";
                            if (estilRang.estil.color) color = InstamapsUtils.Colors.hexToRgb(estilRang.estil.color);
                            else color = InstamapsUtils.Colors.hexToRgb(estilRang.estil.borderColor);
                            var borderColor = InstamapsUtils.Colors.hexToRgb(estilRang.estil.borderColor);
                            var opacity = estilRang.estil.opacity;
                            if (opacity!==0.25 && opacity!==0.5 && opacity!==0.75) opacity = opacity/100;
                            var borderWidth = estilRang.estil.borderWidth;		
                            if (borderWidth==0) borderWidth=1;
                            var stringStyle =	'<svg height="20" width="20">'+
                                '<polygon points="5 5, 5 25, 25 25, 25 5" stroke-linejoin="round" '+
                                    'style=" fill:'+InstamapsUtils.Colors.getRgbText(color)+'; stroke:'+InstamapsUtils.Colors.getRgbText(borderColor)+'; stroke-width:'+borderWidth+'; fill-rule:evenodd; fill-opacity:'+opacity+';"></polygon>'+
                                '</svg>';					
                            
                            var labelNomCategoria = "";
                            checked = "";
                            
                            var index=-1;
                            if (undefined!=mapLegend[layer.options.businessId]) {
                                index = mapLegend[layer.options.businessId]?findStyleInLegend(mapLegend[layer.options.businessId],stringStyle):-1;
                            }
                            
                            if(index != -1){//Si l'ha trobat, fica el seu check i el seu name
                                labelNomCategoria = mapLegend[layer.options.businessId][index].name;
                                if(mapLegend!=undefined && mapLegend[layer.options.businessId]!=undefined && mapLegend[layer.options.businessId][index].chck == true) checked = 'checked="checked"';
                            }else{
                                if(estilRang.valueMax == estilRang.valueMin){
                                    labelNomCategoria = estilRang.valueMax;
                                }else{
                                    labelNomCategoria = estilRang.valueMin +" - "+ estilRang.valueMax;
                                }
                                
                                if(labelNomCategoria == "Altres"){
                                    labelNomCategoria = window.lang.translate("Altres");
                                }
                                if (layer.options.tem=='sizeTematic'){
                                    if (labelNomCategoria.indexOf('('+map[estilRang.estil.simbolSize]+')')==-1){
                                        labelNomCategoria = labelNomCategoria+' ('+map[estilRang.estil.simbolSize]+')';
                                    }
                                    
                                }
                                else{
                                    if (labelNomCategoria.indexOf('('+map[estilRang.estil.color]+')')==-1){
                                        labelNomCategoria = labelNomCategoria+' ('+map[estilRang.estil.color]+')';
                                    }
                                    
                                }
                                
                            }	
                            html += '<div class="legend-subrow " data-businessid="'+layer.options.businessId+'">';
                            html += '<input class="col-md-1 legend-chck" type="checkbox" '+checked+' >';
                            html +=	'<div class="col-md-2 legend-symbol"  data-estilkey="'+key+'">'+
                                        stringStyle+
                                    '</div>'+
                                    '<div class="col-md-9 legend-name">'+
                                        '<input type="text" class="form-control my-border" value="'+labelNomCategoria+ '">'+
                                    '</div>';				
                            html+='</div>';	
                            
                        });						
                        
                    }
                 
             }else{
                     var estil_do = layer.options.estil_do;
                     if (layer.options.dinamic) estil_do = layer.options.style;
                
                     if (estil_do==undefined) estil_do = InstamapsUtils.Styles.retornaEstilaDO(defaultPunt);
                     
                    if(geometrytype == t_marker){
                        var key = estil_do.codiUnic;
                        var mida = InstamapsUtils.Styles.getMidaFromRadius(estil_do.radius);
                        if (layer.options.tem == tem_size) mida = estil_do.simbolSize;
                        var size = 'width: '+mida+'px; height: '+mida+'px; font-size: 8px;';			
                        var color = InstamapsUtils.Colors.hexToRgb(estil_do.fillColor);
                        
                        if (layerName.indexOf('('+layer.getLayers().length+')')==-1){
                            layerName=layerName+' ('+layer.getLayers().length+')';
                        }
                        
                        html += '<div class="legend-subrow " data-businessid="'+layer.options.businessId+'">';
                        html += '<input class="col-md-1 legend-chck" type="checkbox" '+checked+' >';
                        html +=	'<div class="col-md-2 legend-symbol"  data-estilkey="'+key+'">'+
                                    '<div class="awesome-marker-web awesome-marker-icon-punt_r legend-symbol" '+
                                        'style="background-color: '+InstamapsUtils.Colors.getRgbText(color)+'; '+
                                        ' '+size+'">'+
                                    '</div>'+
                                '</div>'+
                                '<div class="col-md-9 legend-name">'+
                                    '<input type="text" class="form-control my-border" value="'+layerName+'">'+
                                '</div>';
                        html+='</div>';
                        
                    }else if(geometrytype == t_polygon){
                        var key = estil_do.codiUnic;
                        var color = "";
                        if (estil_do.fillColor) color=InstamapsUtils.Colors.hexToRgb(estil_do.fillColor);
                        else color=InstamapsUtils.Colors.hexToRgb(estil_do.color);
                        var borderColor = InstamapsUtils.Colors.hexToRgb(estil_do.color);
                        var opacity = estil_do.fillOpacity;
                        var borderWidth = estil_do.weight;		
                        if (borderWidth==0) borderWidth=1;
                        var polStyle =	'<svg height="20" width="20">'+
                            '<polygon points="5 5, 5 25, 25 25, 25 5" '+
                                'style=" fill:'+InstamapsUtils.Colors.getRgbText(color)+'; stroke:'+InstamapsUtils.Colors.getRgbText(borderColor)+'; stroke-width:'+borderWidth+'; fill-rule:evenodd; fill-opacity:'+opacity+';"></polygon>'+
                            '</svg>';
                        
                        if (layerName.indexOf('('+layer.getLayers().length+')')==-1){
                            layerName=layerName+' ('+layer.getLayers().length+')';
                        }
                        
                        html += '<div class="legend-subrow " data-businessid="'+layer.options.businessId+'">';
                        html += '<input class="col-md-1 legend-chck" type="checkbox" '+checked+' >';					
                        html += '<div class="col-md-2 legend-symbol"  data-estilkey="'+key+'">'+
                                    polStyle+
                                '</div>'+
                                '<div class="col-md-9 legend-name">'+
                                    '<input type="text" class="form-control my-border" value="'+layerName+'">'+
                                '</div>';					
                        
                        html+='</div>';			
                        
                    }else if(geometrytype == t_polyline){
                        var key = estil_do.codiUnic;
                        var color;
                        if (layer.options.dinamic) color = InstamapsUtils.Colors.hexToRgb(estil_do.color);
                        else color = InstamapsUtils.Colors.hexToRgb(estil_do.fillColor);
                        var lineWidth = estil_do.weight;
                        var lineStyle =	'<svg height="20" width="20">'+
                            '<line  x1="0" y1="20" x2="20" y2="0" '+ 
                                'style="stroke:'+InstamapsUtils.Colors.getRgbText(color)+'; stroke-width:'+lineWidth+';"></line>'+
                            '</svg>';	
                        
                        if (layerName.indexOf('('+layer.getLayers().length+')')==-1){
                            layerName=layerName+' ('+layer.getLayers().length+')';
                        }
                        
                        html += '<div class="legend-subrow " data-businessid="'+layer.options.businessId+'">';
                        html += '<input class="col-md-1 legend-chck" type="checkbox" '+checked+' >';	
                        html += '<div class="col-md-2 legend-symbol"  data-estilkey="'+key+'">'+
                                    lineStyle +
                                '</div>'+
                                '<div class="col-md-9 legend-name">'+
                                    '<input type="text" class="form-control my-border" value="'+layerName+'">'+
                                '</div>';					
                        html+='</div>';				
                    }			 
             }
             return html;
        }

        static getRowSimpleTematicLayer(layer,checked,layerName,mapLegend){
            var html='';
            if (mapLegend!==undefined){
                if (mapLegend[layer.options.businessId]!==undefined){
                    var legend = mapLegend[layer.options.businessId];
                    for(var i=0; i<legend.length;i++){
                        html += EditorLegend.getRowFromMapLegend(layer.options.businessId,layer.options.tem,legend[i]);
                    }
                }
                else {
                    html += EditorLegend.getRowSimpleTematicLayerIndividual(layer,checked,layerName);
                }
                
            }
            else{
               html += EditorLegend.getRowSimpleTematicLayerIndividual(layer,checked,layerName);
            }
            return html;
        }

        static getRowSimpleTematicLayerIndividual(layer,checked,layerName){
            var html='';
            var keys = [];
            if (layer.options.estil!==undefined && layer.options.estil.length>0){
                for (var j=0;j<layer.options.estil.length;j++){
                    keys[j] = {
                        businessId : layer.options.estil[j].businessId,
                        countF : layer.options.estil[j].geometria.features.length,
                        features: layer.options.estil[j].geometria.features,
                        id: layer.options.estil[j].id
                    };
                }
            }
            else {
                keys[0] = {
                    businessId : layer.options.businessId,
                    countF : 1,
                    features: "",
                    id: ""               
                };
            }
            var rangs = EditorLegend.getRangsFromLayerLegend(layer);
            var size = rangs.length;
            //Si es simpleTematic, amb el primer element de rang ja tenim prou, no ens cal recorrer tots el rangs 
			//pq seran tots iguals
			if(layer.options.tipusRang && layer.options.tipusRang==tem_simple){
				if(size > 0) size = 1;//Control rangs no buit
            }
            var estilsRangs="";
            if (layer.options.estilsRangs!==undefined) estilsRangs = layer.options.estilsRangs;
            var resultat = '';
            var entrades = Object.entries(estilsRangs);
          // if (estilsRangs!=="") rangs = EditorLegend.reorderWithEstilsRangs(rangs,estilsRangs);
            var geometryType = InstamapsUtils.Geo.transformTipusGeometry(layer.options.geometryType, InstamapsConstants);
           
			if(geometryType == t_marker){
				for(var i=0;i<size;i++){
                    var keyTrobat =EditorLegend.findBusinessidInEstil(rangs[i].valorMax,keys);
					//Si es un punt
					if(rangs[i].isCanvas || rangs[i].marker.indexOf("punt_r")!=-1){
						var iconSize="";
						if(rangs[i].iconSize){
							var mides = rangs[i].iconSize.split("#");
							iconSize = 'width: '+mides[0]+'px; height: '+mides[1]+'px;';
						}else{
							var mida = InstamapsUtils.Styles.getMidaFromRadius(rangs[i].simbolSize);
							if (layer.options.tem == tem_size) mida = rangs[i].simbolSize;
							iconSize = 'width: '+mida+'px; height: '+mida+'px; font-size: 8px;';
                        }
                       var color = InstamapsUtils.Colors.hexToRgb(rangs[i].color);
						var icon = "";
						var colorIcon=""; 
						if(rangs[i].simbolColor){
							var auxColor = InstamapsUtils.Colors.hexToRgb(rangs[i].simbolColor);
							colorIcon = 'color: '+InstamapsUtils.Colors.getRgbText(auxColor)+';';
						} 
						
						if(rangs[i].simbol){
							icon = "fa fa-"+rangs[i].simbol;
                        }
                        if (color===null){
                            color = "#f5f5f5";
                        }
                        if (colorIcon===null){
                            colorIcon= "#f5f5f5";
                        }
						var obj = {iconSize: iconSize, color: color, icon:icon, colorIcon: colorIcon};
						var existeix = checkPointStyle(obj);
						
						if(!existeix){
                            controlLegendPoint.push(obj);
                           	var stringStyle = '<div class="awesome-marker-web awesome-marker-icon-punt_r '+icon+' legend-symbol" '+
									'style="background-color: '+InstamapsUtils.Colors.getRgbText(color)+'; '+colorIcon+
									' '+iconSize+'">'+
								'</div>';

							//Reinicialitzem
                            layerName = layer.options.nom;
                            
                            
                            checked = "";	
                            var estilkey = '';
                            var layerNameFound = '';
                            if (keyTrobat.businessId!==undefined){
                                estilkey = keyTrobat.businessId;
                            }					
							var index=-1;
							if (undefined!=mapLegend[layer.options.businessId]) {
								index = mapLegend[layer.options.businessId]?findStyleInLegend(mapLegend[layer.options.businessId],stringStyle):-1;
							}
							if(index != -1){//Si l'ha trobat, fica el seu check i el seu name
                                layerName = mapLegend[layer.options.businessId][index].name;
                                layerNameFound=layerName;
								if(mapLegend[layer.options.businessId][index].chck == true) checked = 'checked="checked"';
                            }		
                            else {
                                layerNameFound = EditorLegend.findLayerNameInEstilRang (estilsRangs,keyTrobat.id);
                                if (layerNameFound!==undefined && layerNameFound.trim()!=="") layerName =  layerNameFound;
                            }

                            if (keyTrobat!==undefined && layerNameFound===''){
                                if (keyTrobat.countF!==undefined){
                                    if (layerName.indexOf('('+keyTrobat.countF+')')==-1){
                                        layerName=layerName+' ('+keyTrobat.countF+')';
                                    }
                                }
                                else {
                                    if (keys[0]!==undefined && keys[0].countF!==undefined) {
                                        if (layerName.indexOf('('+keys[0].countF+')')==-1){
                                            layerName=layerName+' ('+keys[0].countF+')';
                                        }
                                    }
                                }
                            }
                           
							html += '<div class="legend-subrow " data-businessid="'+layer.options.businessId+'">';
							html += '<input class="col-md-1 legend-chck" type="checkbox" '+checked+' >';					
							html +=	'<div class="col-md-2 legend-symbol"  data-estilkey="'+estilkey+'">'+
									stringStyle+
								'</div>'+
								'<div class="col-md-9 legend-name">'+
									'<input type="text" class="form-control my-border" value="'+layerName+'">'+
								'</div></div>';								
						}
					}else{//Si es un pintxo
						
						var color;
						if (rangs[i].marker!=undefined) {
							color = InstamapsUtils.Styles.getColorFromClass(rangs[i].marker);
						}
						else if (rangs[i].simbolColor!=undefined){
							color = InstamapsUtils.Colors.hexToRgb(rangs[i].simbolColor);
						} 
						
						var obj = {color: color, marker: rangs[i].marker, simbol: rangs[i].simbol};
						var existeix = checkMarkerStyle(obj);
						
						if(!existeix){
							controlLegendMarker.push(obj);
							
							var stringStyle = '<div class="awesome-marker-web awesome-marker-icon-'+rangs[i].marker+'" '+
                                    'style="width: 28px; height: 42px; font-size: 14px;background-color: transparent; color: '+InstamapsUtils.Colors.getRgbText(color)+';">'+
                                    '<i style="color: #000000" class="fa fa-'+rangs[i].simbol+ '"></i>'+
								'</div>';
	
							//Reinicialitzem
                            layerName = layer.options.nom;
                            
							checked = "";						
                            var index=-1;
                            var estilkey = '';
                            var layerNameFound='';
                            if (keyTrobat.businessId!==undefined){
                                estilkey = keyTrobat.businessId;
                            }
							if (undefined!=mapLegend[layer.options.businessId]) {
								index = mapLegend[layer.options.businessId]?findStyleInLegend(mapLegend[layer.options.businessId],stringStyle):-1;
							}
							if(index != -1){//Si l'ha trobat, fica el seu check i el seu name
                                layerName = mapLegend[layer.options.businessId][index].name;
                                layerNameFound=layerName;
								if(mapLegend[layer.options.businessId][index].chck == true) checked = 'checked="checked"';
                            }	
                            else {
                                layerNameFound = EditorLegend.findLayerNameInEstilRang (estilsRangs,keyTrobat.id);
                                if (layerNameFound!==undefined && layerNameFound.trim()!=="") layerName =  layerNameFound;
                            }	
                            if (keyTrobat!==undefined && layerNameFound===''){
                                if (keyTrobat.countF!==undefined){
                                    if (layerName.indexOf('('+keyTrobat.countF+')')==-1){
                                        layerName=layerName+' ('+keyTrobat.countF+')';
                                    }
                                }
                                else {
                                    if (keys[0]!==undefined && keys[0].countF!==undefined) {
                                        if (layerName.indexOf('('+keys[0].countF+')')==-1){
                                            layerName=layerName+' ('+keys[0].countF+')';
                                        }
                                    }
                                }
                            }
							
							html += '<div class="legend-subrow " data-businessid="'+layer.options.businessId+'">';
							html += '<input class="col-md-1 legend-chck" type="checkbox" '+checked+' >';						
							html += '<div class="col-md-2 legend-symbol"  data-estilkey="'+estilkey+'">'+
									stringStyle+
								'</div>'+
								'<div class="col-md-9 legend-name">'+
									'<input type="text" class="form-control my-border" value="'+layerName+'">'+
								'</div></div>';							
						}
					}
                }		
			}else if(geometryType == t_polyline){
				
				for(var i=0;i<size;i++){
                    var keyTrobat =EditorLegend.findBusinessidInEstil(rangs[i].valorMax,keys);
					var color = InstamapsUtils.Colors.hexToRgb(rangs[i].color);
					var lineWidth = rangs[i].lineWidth;
	
					var obj = {color: color, lineWidth: lineWidth};
					var existeix = checkLineStyle(obj);
					
					if(!existeix){
						controlLegendLine.push(obj);
						
						var stringStyle =	'<svg height="20" width="20">'+
							'<line x1="0" y1="20" x2="20" y2="0" '+
								'style="stroke:'+InstamapsUtils.Colors.getRgbText(color)+'; stroke-width:'+lineWidth+';"></line>'+
							'</svg>';
						//Reinicialitzem
                        layerName = layer.options.nom;
                        
						checked = "";						
                        var index=-1;
                        var estilkey = '';
                        var layerNameFound = '';
                        if (keyTrobat.businessId!==undefined){
                            estilkey = keyTrobat.businessId;
                        }	
						if (undefined!=mapLegend[layer.options.businessId]) {
							index = mapLegend[layer.options.businessId]?findStyleInLegend(mapLegend[layer.options.businessId],stringStyle):-1;
						}
						if(index != -1){//Si l'ha trobat, fica el seu check i el seu name
                            layerName = mapLegend[layer.options.businessId][index].name;
                            layerNameFound = layerName;
							if(mapLegend[layer.options.businessId][index].chck == true) checked = 'checked="checked"';
                        }		
                        else {
                            layerNameFound = EditorLegend.findLayerNameInEstilRang (estilsRangs,keyTrobat.id);
                            if (layerNameFound!==undefined && layerNameFound.trim()!=="") layerName =  layerNameFound;
                        }	
                        if (keyTrobat!==undefined && layerNameFound===''){
                            if (keyTrobat.countF!==undefined){
                                if (layerName.indexOf('('+keyTrobat.countF+')')==-1){
                                    layerName=layerName+' ('+keyTrobat.countF+')';
                                }
                            }
                            else {
                                if (keys[0]!==undefined && keys[0].countF!==undefined) {
                                    if (layerName.indexOf('('+keys[0].countF+')')==-1){
                                        layerName=layerName+' ('+keys[0].countF+')';
                                    }
                                }
                            }
                        }
						html += '<div class="legend-subrow " data-businessid="'+layer.options.businessId+'">';
						html += '<input class="col-md-1 legend-chck" type="checkbox" '+checked+' >';	
						html += '<div class="col-md-2 legend-symbol"  data-estilkey="'+estilkey+'">'+
								stringStyle +
							'</div>'+
							'<div class="col-md-9 legend-name">'+
								'<input type="text" class="form-control my-border" value="'+layerName+'">'+
							'</div>';					
						
						html+='</div>';						
					}
				}				
			}else if(geometryType == t_polygon){
				
				for(var i=0;i<size;i++){
                    var keyTrobat =EditorLegend.findBusinessidInEstil(rangs[i].valorMax,keys);
					var color = "";
					if (rangs[i].color) color=InstamapsUtils.Colors.hexToRgb(rangs[i].color);
					else color=InstamapsUtils.Colors.hexToRgb(rangs[i].borderColor);
					var borderColor = InstamapsUtils.Colors.hexToRgb(rangs[i].borderColor);
                    var opacity = rangs[i].opacity;
                    if (opacity!==0.25 && opacity!==0.5 && opacity!==0.75) opacity = opacity/100;
					var borderWidth = rangs[i].borderWidth;
					if (borderWidth==0) borderWidth=1;
					var obj = {color: color, borderColor: borderColor, opacity:opacity, borderWidth:borderWidth};
					var existeix = checkPolStyle(obj);					
					
					if(!existeix){
						controlLegendPol.push(obj);					
					
						var stringStyle =	'<svg height="30" width="30">'+
								'<polygon points="5 5, 5 25, 25 25, 25 5" '+
									'style=" fill:'+InstamapsUtils.Colors.getRgbText(color)+'; stroke:'+InstamapsUtils.Colors.getRgbText(borderColor)+'; stroke-width:'+borderWidth+'; fill-rule:evenodd; fill-opacity:'+opacity+';"></polygon>'+
							'</svg>';
						
						//Reinicialitzem
						layerName = layer.options.nom;
						checked = "";						
                        var index=-1;
                        var estilkey = '';
                        var layerNameFound = '';
                        if (keyTrobat.businessId!==undefined){
                            estilkey = keyTrobat.businessId;
                        }	
						if (undefined!=mapLegend[layer.options.businessId]) {
							index = mapLegend[layer.options.businessId]?findStyleInLegend(mapLegend[layer.options.businessId],stringStyle):-1;
						}
						if(index != -1){//Si l'ha trobat, fica el seu check i el seu name
                            layerName = mapLegend[layer.options.businessId][index].name;
                            layerNameFound = layerName;
							if(mapLegend[layer.options.businessId][index].chck == true) checked = 'checked="checked"';
                        }	
                        else {
                            layerNameFound = EditorLegend.findLayerNameInEstilRang (estilsRangs,keyTrobat.id);
                            if (layerNameFound!==undefined && layerNameFound.trim()!=="") layerName =  layerNameFound;
                        }	
                        if (keyTrobat!==undefined && layerNameFound===''){
                            if (keyTrobat.countF!==undefined){
                                if (layerName.indexOf('('+keyTrobat.countF+')')==-1){
                                    layerName=layerName+' ('+keyTrobat.countF+')';
                                }
                            }
                            else {
                                if (keys[0]!==undefined && keys[0].countF!==undefined) {
                                    if (layerName.indexOf('('+keys[0].countF+')')==-1){
                                        layerName=layerName+' ('+keys[0].countF+')';
                                    }
                                }
                            }
                        }
                       			
						html += '<div class="legend-subrow " data-businessid="'+layer.options.businessId+'">';
						html += '<input class="col-md-1 legend-chck" type="checkbox" '+checked+' >';					
						html += '<div class="col-md-2 legend-symbol"  data-estilkey="'+estilkey+'">'+
								stringStyle+
							'</div>'+
							'<div class="col-md-9 legend-name">'+
								'<input type="text" class="form-control my-border" value="'+layerName+'">'+
							'</div>';					
						
						html+='</div>';
					}
					
				}
            }
            return html;
        }
        static getStringStyleByGeometryType(geometryType,layer,indexEstil){
            var stringStyle = "";
            var color = "";
            var rangs = EditorLegend.getRangsFromLayerLegend(layer);
            var size = rangs.length;
            if(layer.options.tipusRang && layer.options.tipusRang==tem_simple){
				if(size > 0) size = 1;//Control rangs no buit
			}
            if(geometryType == t_marker){
               
                var mida = InstamapsUtils.Styles.getMidaFromRadius(layer.options.estil[indexEstil].simbolSize);
                if (layer.options.tipusRang == tem_size || (layer.options.tem!==undefined && layer.options.tem==tem_size)) {
                    mida = layer.options.estil[indexEstil].simbolSize;
                    if (mida>60) mida=60;
                }
                var iconSize = 'width: '+mida+'px; height: '+mida+'px; font-size: 8px;';						
                color = InstamapsUtils.Colors.hexToRgb(layer.options.estil[indexEstil].color);
                if (layer.options.tipusRang == tem_size || (layer.options.tem!==undefined && layer.options.tem==tem_size)) {
                    stringStyle =	InstamapsUtils.Styles.getSvgForLegendFromRadius(mida,color,$(location).attr('href'));
                }
                else {
                    stringStyle ='<div class="awesome-marker-web awesome-marker-icon-punt_r legend-symbol" '+
                        'style="background-color: '+InstamapsUtils.Colors.getRgbText(color)+'; '+
                        ' '+iconSize+'">'+
                        '</div>';
                }
            }
            else if(geometryType == t_polyline){
                color = InstamapsUtils.Colors.hexToRgb(layer.options.estil[indexEstil].color);
                var lineWidth = layer.options.estil[indexEstil].lineWidth;
                stringStyle =	'<svg height="20" width="20">'+
                    '<line x1="0" y1="20" x2="20" y2="0" '+
                        'style="stroke:'+InstamapsUtils.Colors.getRgbText(color)+'; stroke-width:'+lineWidth+';"></line>'+
                    '</svg>';	
            }
            else {
                
                if (layer.options.estil[indexEstil].color) color=InstamapsUtils.Colors.hexToRgb(layer.options.estil[indexEstil].color);
                else color = InstamapsUtils.Colors.hexToRgb(layer.options.estil[indexEstil].borderColor);
                var borderColor = InstamapsUtils.Colors.hexToRgb(layer.options.estil[indexEstil].borderColor);
                var opacity = layer.options.estil[indexEstil].opacity;
                if (opacity!==0.25 && opacity!==0.5 && opacity!==0.75) opacity = opacity/100;
                var borderWidth = layer.options.estil[indexEstil].borderWidth;			
                if (borderWidth==0) borderWidth=1;
                var stringStyle =	'<svg height="20" width="20">'+
                    '<polygon points="5 5, 5 25, 25 25, 25 5" stroke-linejoin="round" '+
                        'style=" fill:'+InstamapsUtils.Colors.getRgbText(color)+'; stroke:'+InstamapsUtils.Colors.getRgbText(borderColor)+'; stroke-width:'+borderWidth+'; fill-rule:evenodd; fill-opacity:'+opacity+';"></polygon>'+
                    '</svg>';
            }
            return stringStyle;
        }

        static getRowLayerHtml(mapLegend,layer,rangsEstilsLegend,indexEstil,geometryType,key){
            var index=-1;
            var html='';
            var checked='';
            var stringStyle = EditorLegend.getStringStyleByGeometryType(geometryType,layer,indexEstil);
            if (undefined!=mapLegend[layer.options.businessId]) {
                index = mapLegend[layer.options.businessId]?findStyleInLegend(mapLegend[layer.options.businessId],stringStyle):-1;
            }
           	
            var labelNomCategoria = EditorLegend.getLabelNomCategoria(layer,rangsEstilsLegend,index,indexEstil,mapLegend);		
            if (index==-1) index=0;	           	
            if(mapLegend!=undefined && mapLegend[layer.options.businessId]!=undefined && mapLegend[layer.options.businessId][index].chck == true) checked = 'checked="checked"';


            var padding_left="16px !important";                
                    
            html += '<li class="legend-subrow " data-businessid="'+layer.options.businessId+'">';
            html += '<input class="col-md-1 legend-chck" type="checkbox" '+checked+' >';
            if (layer.options.tem == tem_size) {
                html +=	'<div class="col-md-2 legend-symbol" style="padding-left:'+padding_left+'" data-estilkey="'+key+'">';
            }
            else {
                html +=	'<div class="col-md-2 legend-symbol" data-estilkey="'+key+'">';
            }
           
            html +=  stringStyle+'</div>'+
                    '<div class="col-md-9 legend-name">'+
                        '<input type="text" class="form-control my-border" value="'+labelNomCategoria +'">'+
                    '</div>';				
            html+='</li>';	
            return html;
        }

        static getLabelNomCategoria(layer,rangsEstilsLegend,index,indexEstil,mapLegend){
            var labelNomCategoria="";
            if(index != -1){//Si l'ha trobat, fica el seu check i el seu name
                labelNomCategoria = mapLegend[layer.options.businessId][index].name;
                if (labelNomCategoria===undefined) {
                    labelNomCategoria=rangsEstilsLegend[""+layer.options.estil[indexEstil].businessId+""];
                }
               
            }else{
                labelNomCategoria = rangsEstilsLegend[""+layer.options.estil[indexEstil].businessId+""];
                
                if(labelNomCategoria === "Altres"){
                    labelNomCategoria = window.lang.translate("Altres");
                }
                if (labelNomCategoria.indexOf('('+layer.options.estil[indexEstil].geometria.features.length+')')==-1){
                    labelNomCategoria = labelNomCategoria +' ('+layer.options.estil[indexEstil].geometria.features.length+')';
                }
            }						
            
            return labelNomCategoria;
            
        }

        static getRangsFromLayerLegend(layer){
            var styles = jQuery.map(layer.getLayers(), function(val, i){
                //Si la layer es multipoligon ha d'agafa l'estil de les seves layers de dins
                if(val.options.tipus && val.options.tipus.indexOf(t_multipolygon)!= -1){
                    return {key: val.properties.businessId, style: val.getLayers()[0], id: val.properties.estil.id};
                }else{
                    return {key: val.properties.businessId, style: val, id: val.properties.estil.id};
                }
            });
            
            var tematic = layer.options;
            tematic.tipusRang = tematic.tipusRang ? tematic.tipusRang : tem_origen;
            tematic.businessid = tematic.businessId; 
            tematic.leafletid = layer._leaflet_id;
            tematic.geometrytype = tematic.geometryType;
            tematic.from = tematic.tipusRang;
            
            var rangs = getRangsFromStyles(tematic, styles);
            //rangs = JSON.stringify({rangs:rangs});	
            
            return rangs;
        }

        static findBusinessidInEstil(businessId,estils){
           for (var j=0;j<estils.length;j++){
                var estil = estils[j];
                var features = estil.features;
                for (var k=0;k<features.length;k++){
                    var feature = features[k];
                    if (feature.businessId === businessId) {
                        return estil;
                    }
                }
            }
            return '';
        }

        static findLayerNameInEstilRang(estilsRangs,businessId){
            var resultat = '';
            var entrades = Object.entries(estilsRangs);
            jQuery.each(entrades, function(i){
                var entrada = entrades[i];
                if (entrada[1]===businessId) {
                    resultat = entrada[0];
                    return false;
                }
            });
            return resultat;
        }

        static reorderWithEstilsRangs(rangs,estilsRangs){
            var newrangs=[];
            var j=0;           
            var entrades = Object.entries(estilsRangs);
            jQuery.each(entrades, function(i){
                var entrada = entrades[i];
                for(var i=0;i<rangs.length;i++){
                    var rang = rangs[i];
                    if (rang.idestil===entrada[1]){
                        newrangs[j]=rang;
                        j++;
                    }
                }
            });
            return newrangs;
        }

        static reorderWithMapLegend(rangs,mapLegend){
            var newrangs=[];
            var j=0;           
            var entrades = Object.entries(mapLegend);
            jQuery.each(entrades, function(i){
                var entrada = entrades[i];
                for(var i=0;i<rangs.length;i++){
                    var rang = rangs[i];
                    if (rang.idestil===entrada[1]){
                        newrangs[j]=rang;
                        j++;
                    }
                }
            });
            return newrangs;
        }

        static getRowFromMapLegend(businessId,tem,legend){
            var html='';
            var checked='';
            if(legend.chck == true) checked = 'checked="checked"';


            var padding_left="16px !important";                
                    
            html += '<li class="legend-subrow " data-businessid="'+businessId+'">';
            html += '<input class="col-md-1 legend-chck" type="checkbox" '+checked+' >';
            if (tem == tem_size) {
                html +=	'<div class="col-md-2 legend-symbol" style="padding-left:'+padding_left+'" data-estilkey="'+legend.estilKey+'">';
            }
            else {
                html +=	'<div class="col-md-2 legend-symbol" data-estilkey="'+legend.estilKey+'">';
            }
           
            html +=  legend.symbol+'</div>'+
                    '<div class="col-md-9 legend-name">'+
                        '<input type="text" class="form-control my-border" value="'+legend.name +'">'+
                    '</div>';				
            html+='</li>';	
            return html;
        }
    }

    LegendUtils.EditorLegend = EditorLegend;

    if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
        module.exports = LegendUtils;
    } else {
        window.LegendUtils = LegendUtils;
    }

})();